import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { StakeMoreArrow } from '../../../constants/icon-constants';
import styles from './stake-more.module.scss';
import { OM } from '../../../constants/blockchain-constants';

const StakeMore = ({ type, text }) => (
  <div className={cn(styles.container, styles[type])}>
    <div className={styles.body}>
      <div className={styles.icon}>{StakeMoreArrow}</div>
      <div>{text}</div>
    </div>
  </div>
);

StakeMore.propTypes = {
  type: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  image: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

StakeMore.defaultProps = {
  type: OM,
  disabled: false,
  onClick: () => {},
};

export default StakeMore;
